var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var StreamTransport;
    (function (StreamTransport) {
        StreamTransport[StreamTransport["Udp"] = 0] = "Udp";
        StreamTransport[StreamTransport["Rtp"] = 1] = "Rtp";
    })(StreamTransport = exports.StreamTransport || (exports.StreamTransport = {}));
    var StreamEncoding;
    (function (StreamEncoding) {
        StreamEncoding[StreamEncoding["Mp2t"] = 0] = "Mp2t";
    })(StreamEncoding = exports.StreamEncoding || (exports.StreamEncoding = {}));
    var AssetEntryUsage;
    (function (AssetEntryUsage) {
        AssetEntryUsage[AssetEntryUsage["main"] = 0] = "main";
        AssetEntryUsage[AssetEntryUsage["transcode"] = 1] = "transcode";
        AssetEntryUsage[AssetEntryUsage["fallback"] = 2] = "fallback";
        AssetEntryUsage[AssetEntryUsage["thumbnail"] = 3] = "thumbnail";
        AssetEntryUsage[AssetEntryUsage["userthumbnail"] = 4] = "userthumbnail";
        AssetEntryUsage[AssetEntryUsage["previewvideo"] = 5] = "previewvideo";
        AssetEntryUsage[AssetEntryUsage["previewgif"] = 6] = "previewgif";
    })(AssetEntryUsage = exports.AssetEntryUsage || (exports.AssetEntryUsage = {}));
    var TranscoderJobTypes;
    (function (TranscoderJobTypes) {
        TranscoderJobTypes[TranscoderJobTypes["Gif"] = 0] = "Gif";
        TranscoderJobTypes[TranscoderJobTypes["Preview"] = 1] = "Preview";
        TranscoderJobTypes[TranscoderJobTypes["QHD"] = 2] = "QHD";
        TranscoderJobTypes[TranscoderJobTypes["HD"] = 3] = "HD";
        TranscoderJobTypes[TranscoderJobTypes["UHD"] = 4] = "UHD";
        TranscoderJobTypes[TranscoderJobTypes["Thumbnail"] = 5] = "Thumbnail";
        TranscoderJobTypes[TranscoderJobTypes["Metadata"] = 6] = "Metadata";
    })(TranscoderJobTypes = exports.TranscoderJobTypes || (exports.TranscoderJobTypes = {}));
    var TranscoderStatusTypes = (function () {
        function TranscoderStatusTypes() {
        }
        TranscoderStatusTypes.Error = "Error";
        TranscoderStatusTypes.Skipped = "Skipped";
        TranscoderStatusTypes.Downloaded = "Downloaded";
        TranscoderStatusTypes.Started = "Started";
        TranscoderStatusTypes.Finished = "Finished";
        return TranscoderStatusTypes;
    }());
    exports.TranscoderStatusTypes = TranscoderStatusTypes;
    var AssetEntryTypes = (function () {
        function AssetEntryTypes() {
        }
        AssetEntryTypes.Image = "image";
        AssetEntryTypes.Video = "video";
        AssetEntryTypes.Website = "website";
        AssetEntryTypes.Stream = "stream";
        AssetEntryTypes.TVChannel = "tvchannel";
        AssetEntryTypes.FreeText = "freetext";
        return AssetEntryTypes;
    }());
    exports.AssetEntryTypes = AssetEntryTypes;
    var TranscoderPathPrefixes = (function () {
        function TranscoderPathPrefixes() {
        }
        TranscoderPathPrefixes.Gif = "preview-gif/";
        TranscoderPathPrefixes.Preview = "preview/";
        TranscoderPathPrefixes.Thumbnail = "thumb/";
        TranscoderPathPrefixes.CustomThumbnail = "customthumb/";
        TranscoderPathPrefixes.QHD = "transcode/qhd/";
        TranscoderPathPrefixes.HD = "transcode/hd/";
        TranscoderPathPrefixes.UHD = "transcode/uhd/";
        return TranscoderPathPrefixes;
    }());
    exports.TranscoderPathPrefixes = TranscoderPathPrefixes;
    var BaseAssetEntry = (function () {
        function BaseAssetEntry() {
            this.Id = "";
            this.CreatedBy = "";
            this.TranscoderStatus = TranscoderStatusTypes.Finished;
        }
        return BaseAssetEntry;
    }());
    exports.BaseAssetEntry = BaseAssetEntry;
    var NumDenum = (function () {
        function NumDenum() {
        }
        return NumDenum;
    }());
    exports.NumDenum = NumDenum;
    var UploadedAssetEntry = (function (_super) {
        __extends(UploadedAssetEntry, _super);
        function UploadedAssetEntry() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.Url = "";
            _this.Width = 0;
            _this.Height = 0;
            _this.Rotation = 0;
            _this.AspectRatio = new NumDenum();
            return _this;
        }
        return UploadedAssetEntry;
    }(BaseAssetEntry));
    exports.UploadedAssetEntry = UploadedAssetEntry;
    var ImageAssetEntry = (function (_super) {
        __extends(ImageAssetEntry, _super);
        function ImageAssetEntry() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.Type = AssetEntryTypes.Image;
            return _this;
        }
        return ImageAssetEntry;
    }(UploadedAssetEntry));
    exports.ImageAssetEntry = ImageAssetEntry;
    var VideoAssetEntry = (function (_super) {
        __extends(VideoAssetEntry, _super);
        function VideoAssetEntry() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.Type = AssetEntryTypes.Video;
            _this.PixelAspectRatio = new NumDenum();
            return _this;
        }
        return VideoAssetEntry;
    }(UploadedAssetEntry));
    exports.VideoAssetEntry = VideoAssetEntry;
    var StreamAssetEntry = (function (_super) {
        __extends(StreamAssetEntry, _super);
        function StreamAssetEntry() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.Type = AssetEntryTypes.Stream;
            _this.Transport = null;
            _this.Encoding = null;
            _this.Deinterlace = 'Auto';
            _this.Latency = 12;
            _this.Volume = 1;
            return _this;
        }
        return StreamAssetEntry;
    }(VideoAssetEntry));
    exports.StreamAssetEntry = StreamAssetEntry;
    var TVChannelAssetEntry = (function (_super) {
        __extends(TVChannelAssetEntry, _super);
        function TVChannelAssetEntry() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return TVChannelAssetEntry;
    }(StreamAssetEntry));
    exports.TVChannelAssetEntry = TVChannelAssetEntry;
    var WebsiteAssetEntry = (function (_super) {
        __extends(WebsiteAssetEntry, _super);
        function WebsiteAssetEntry() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.Type = AssetEntryTypes.Website;
            _this.Url = "";
            _this.Width = 0;
            _this.Height = 0;
            _this.Scale = 1.0;
            _this.BackgroundColor = "white";
            return _this;
        }
        return WebsiteAssetEntry;
    }(BaseAssetEntry));
    exports.WebsiteAssetEntry = WebsiteAssetEntry;
    var FreeTextAssetEntry = (function (_super) {
        __extends(FreeTextAssetEntry, _super);
        function FreeTextAssetEntry() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.Type = AssetEntryTypes.FreeText;
            _this.Text = "";
            _this.Color = "#000000";
            return _this;
        }
        return FreeTextAssetEntry;
    }(BaseAssetEntry));
    exports.FreeTextAssetEntry = FreeTextAssetEntry;
});
//# sourceMappingURL=AssetEntry.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/Content/AssetEntry.js
// module id = 383
// module chunks = 0